import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import { ActivityGroupProps } from '~/bootcamp/Activities/types/activities.types'

// Lazy Loaded Modules
const Bootcamp1Activities = dynamic(() => import('./Bootcamp1/Bootcamp1Activities'))
const Bootcamp2Activities = dynamic(() => import('./Bootcamp2/Bootcamp2Activities'))

const PemdasActivities = (activityData: ActivityGroupProps): React.ReactElement => {
  const router = useRouter()
  const { moduleKey } = router.query
  switch (moduleKey) {
    case '1':
      return <Bootcamp1Activities {...activityData} />
    case '2':
      return <Bootcamp2Activities {...activityData} />
    case '3':
      return <></>
    case '4':
      return <></>
    case '5':
      return <></>
    default:
      return <></>
  }
}

export default PemdasActivities
